// The Availability editor's shared class strings (NO-878). Tokens only: the
// editor renders in the always frame, where these resolve to the always theme.

/** A white card on a 14% plum line, 22px radius (the canvas card frame). */
export const CARD =
  "rounded-xl border border-(color:--surface-line,var(--border)) bg-card";

/** A hairline inside a card. */
export const RULE = "border-(color:--surface-line,var(--border))";

export const FOCUS =
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring";

/** The display face for card titles and figures. */
export const DISPLAY_TITLE = "font-sans text-title font-bold leading-[1.25]";
